import React, { Component } from "react"
import styled from "styled-components"
import ScreensizeProvider from "../components/ScreensizeProvider"
import Footer from "./Footer"
import Nav from "./Nav"

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1400px
  padding: 1rem 1.5rem;

  @media (max-width: 768px) {
    padding-top: 50px;
  }
`

export default function Layout({ children, location }) {
  console.log("Layout")
  return (
    <Container>
      <Nav location={location} />
      <ScreensizeProvider>{children()}</ScreensizeProvider>
      <Footer />
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/index.js